import { useEffect, useState } from "react";
import { doc, onSnapshot, setDoc, deleteDoc } from "firebase/firestore";
import { db, ensureSignedIn } from "./firebase";
import Intro from "./scenes/Intro";
import Questionnaire from "./scenes/Questionnaire";
import HerQuestions from "./scenes/HerQuestions";
import MiniGame from "./scenes/MiniGame";
import DateAsk from "./scenes/DateAsk";
import Finale from "./scenes/Finale";
import useUiSounds from "./useUiSounds";
import "./styles.css";

const SESSION_ID = "grey";

// === Reset password — change this to whatever you want ===
const RESET_PASSWORD = "shooters";

export default function App() {
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);
  const [error, setError] = useState(null);

  useUiSounds();

  useEffect(() => {
    ensureSignedIn()
      .then(setUser)
      .catch((e) => setError(e.message));
  }, []);

  useEffect(() => {
    if (!user) return;
    const ref = doc(db, "sessions", SESSION_ID);
    const unsub = onSnapshot(ref, (snap) => {
      setSession(
        snap.exists()
          ? snap.data()
          : { scene: "intro", answers: {}, herQuestions: ["", "", ""] }
      );
    });
    return unsub;
  }, [user]);

  const update = async (patch) => {
    const ref = doc(db, "sessions", SESSION_ID);
    await setDoc(ref, patch, { merge: true });
  };

  const goTo = (scene) => update({ scene });

  const handleReset = async () => {
    const input = window.prompt("password:");
    if (input === null) return; // cancelled
    if (input !== RESET_PASSWORD) {
      window.alert("nope.");
      return;
    }
    const ok = window.confirm(
      "this will wipe ALL answers and start fresh. continue?"
    );
    if (!ok) return;
    try {
      await deleteDoc(doc(db, "sessions", SESSION_ID));
      window.location.reload();
    } catch (e) {
      window.alert("reset failed: " + e.message);
    }
  };

  if (error) return <div className="loading">connection error: {error}</div>;
  if (!user || !session) return <div className="loading">loading…</div>;

  const sceneProps = { session, update, goTo };

  return (
    <div className="App">
      {session.scene === "intro" && <Intro {...sceneProps} />}
      {session.scene === "questionnaire" && <Questionnaire {...sceneProps} />}
      {session.scene === "herQuestions" && <HerQuestions {...sceneProps} />}
      {session.scene === "miniGame" && <MiniGame {...sceneProps} />}
      {session.scene === "dateAsk" && <DateAsk {...sceneProps} />}
      {session.scene === "finale" && <Finale {...sceneProps} />}

      {/* hidden reset trigger — bottom-right corner, nearly invisible */}
      <button
        onClick={handleReset}
        title="reset"
        aria-label="reset"
        style={{
          position: "fixed",
          bottom: 8,
          right: 8,
          width: 14,
          height: 14,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          opacity: 0.15,
          padding: 0,
          fontSize: 10,
          color: "var(--muted)",
          zIndex: 100,
        }}
      >
        ·
      </button>
    </div>
  );
}
